import React from 'react';

const IconWarn = props =>
  <svg viewBox="0 0 22 22" width="22px" height="22px" {...props}>
    <path d="M18.741 15.429L12.353 4.775c-0.627-1.045-2.082-1.045-2.709 0L3.255 15.429 c-0.668 1.115 0.097 2.565 1.354 2.565h12.777C18.645 17.994 19.41 16.544 18.741 15.429z M9.77 6.46h2.442 c0.136 0 0.242 0.12 0.233 0.261l-0.403 5.945c-0.009 0.128-0.11 0.228-0.233 0.228h-1.636c-0.123 0-0.224-0.1-0.233-0.228 L9.537 6.722C9.528 6.581 9.635 6.46 9.77 6.46z M11.006 17.102c-0.924 0-1.675-0.295-1.675-1.754s0.751-1.737 1.675-1.737 c0.923 0 1.659 0.278 1.659 1.737S11.929 17.102 11.006 17.102z" />
  </svg>;

export default IconWarn;
